<template>
  <div v-if="timeLeft>0" :style="{ display: 'flex', alignItems: 'center' }">
    <div :style="{
      color: countdownColor,
      fontSize: `${baseFontSize}px`,
    }">{{ frontStr }}</div>
    <span
        :style="{
        color: countdownColor,
        fontSize: `${baseFontSize}px`,
        fontWeight: 'bold',
        margin: margin
      }"
    >
      {{ formattedTime }}
    </span>
    <div :style="{
      color: countdownColor,
      fontSize: `${baseFontSize}px`,
    }">{{ lastStr }}</div>
  </div>
  <div v-if="timeLeft<=0" :style="{ display: 'flex', alignItems: 'center' }">
    <slot/>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, onUnmounted, watch } from 'vue'

  const props = defineProps({
    margin: { type: String, default: '0 4px' },
    isShowHour: { type: Boolean, default: true},
    frontStr: { type: String, default: '' },
    lastStr: { type: String, default: '' },
    countdownSecs: { type: Number, required: true },
    countdownColor: { type: String, default: '#fa1818' },
    countdownFontSizeAdd: { type: Number, default: 0 }
  })

  const baseFontSize = 15 + props.countdownFontSizeAdd

  const timeLeft = ref(props.countdownSecs)
  let timer = null

  const formattedTime = computed(() => {
    const totalSeconds = timeLeft.value
    const days = Math.floor(totalSeconds / 86400)
    const remainderAfterDays = totalSeconds % 86400
    const hours = Math.floor(remainderAfterDays / 3600)
    const remainderAfterHours = remainderAfterDays % 3600
    const minutes = Math.floor(remainderAfterHours / 60)
    const seconds = remainderAfterHours % 60

    const hStr = String(hours).padStart(2, '0')
    const mStr = String(minutes).padStart(2, '0')
    const sStr = String(seconds).padStart(2, '0')

    if(props.isShowHour){
      if (days > 0) {
        return `${days}天 ${hStr}:${mStr}:${sStr}`
      } else {
        return `${hStr}:${mStr}:${sStr}`
      }
    }else{
      return `${mStr}:${sStr}`
    }
  })

  const startCountdown = () => {
    clearInterval(timer)
    timer = setInterval(() => {
      if (timeLeft.value > 0) {
        timeLeft.value--
      } else {
        clearInterval(timer)
      }
    }, 1000)
  }

  onMounted(() => {
    startCountdown()
  })

  onUnmounted(() => {
    clearInterval(timer)
  })

  // 如果传入值变化，重新开始倒计时
  watch(() => props.countdownSecs, (newVal) => {
    timeLeft.value = newVal
    startCountdown()
  })
</script>

<style scoped>
</style>
